import { useState } from 'react';

import { UnsubscribedViewLayout } from '../../../../layout/UnsubscribedViewLayout.tsx';
import type { OnboardingModuleProps } from '../../types.js';

type Props = OnboardingModuleProps & {
  onFinish: () => Promise<void>;
};

export const SubscriptionStep = ({ onFinish, SubscriptionModule }: Props) => {
  const [title, setTitle] = useState('Select a plan');

  return (
    <UnsubscribedViewLayout title={title}>
      <SubscriptionModule
        mode="legacy-new-user-trial"
        onPlanSelect={() => setTitle('Complete checkout')}
        onFinish={onFinish}
      />
    </UnsubscribedViewLayout>
  );
};
